import PropTypes from 'prop-types';

export const propTypes = {
    imageStrokeWidth: PropTypes.number,
    imageStrokeColor: PropTypes.string,
    imageOpacity: PropTypes.number,
    onChangeImageStrokeWidth: PropTypes.func,
    onChangeImageStrokeColor: PropTypes.func,
    onChangeImageOpacity: PropTypes.func,
    imageTintColor: PropTypes.string,
    imageTintStrength: PropTypes.number,
    onChangeImageTintColor: PropTypes.func,
    onChangeImageTintStrength: PropTypes.func,
    onClearImageTint: PropTypes.func,
    selectedElement: PropTypes.object,
    languageLocale: PropTypes.string,
};
